import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'CrmMotivoDescarte';
  const defaultValues = {
    motivo: '',
    ativo: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => navigate(-1),
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(state) ? 'Editar' : 'Cadastrar') + ' Motivo de Descarte'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10}>
            <Input name="motivo" control={control} label="Motivo" />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Dropdown
              name="ativo"
              control={control}
              label="Ativo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
